import functions from "./functions";

const dictionary={
    "_completeFields":"Complete all fields and try again",
    "_toastTimeOut":5000,
    "_uiRefreshRate":1000,
    "_refreshRate": 10000,
    apiHost:functions.getHost(),
    captiveHost:functions.getCaptiveHost(),


}

export default dictionary;